import { render } from "./CreateMandateContract.vue?vue&type=template&id=d0399cb8"
import script from "./CreateMandateContract.vue?vue&type=script&lang=js"
export * from "./CreateMandateContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__